var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGridlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Broken/gridlock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.4166 19.708V16.1247C39.4166 7.16634 35.8333 3.58301 26.875 3.58301H16.125C7.16665 3.58301 3.58331 7.16634 3.58331 16.1247V26.8747C3.58331 35.833 7.16665 39.4163 16.125 39.4163H17.9166M9.01206 15.2288H39.4166M3.63706 27.7705H21.5M15.2471 39.402V3.60451M27.7887 21.4853V3.60451",
    stroke: "currentColor",
    strokeWidth: 2.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.95 30.8163V29.383C27.95 27.0001 28.6666 25.083 32.25 25.083C35.8333 25.083 36.55 27.0001 36.55 29.383V30.8163M35.8333 39.4163H28.6666C25.8 39.4163 25.0833 38.6997 25.0833 35.833V34.3997C25.0833 31.533 25.8 30.8163 28.6666 30.8163H35.8333C38.7 30.8163 39.4166 31.533 39.4166 34.3997V35.833C39.4166 38.6997 38.7 39.4163 35.8333 39.4163Z",
    stroke: "currentColor",
    strokeWidth: 2.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridlock);
export default __webpack_public_path__ + "static/media/gridlock.be9865bbd5baf17c4ad2f7d55a1defd6.svg";
export { ForwardRef as ReactComponent };